// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3LVGa","title":"AfterImages45_title__zBgIY","images":"AfterImages45_images__1terK"};